module.exports = __webpack_public_path__ + "static/media/back-arrow-light.aac88b94.svg";